import React from 'react';
import { Heading, Main, Page, PageContent, Box, Text } from 'grommet';
import { redirect, useLoaderData, useRevalidator } from 'react-router-dom';
import { hasToken, API, AppConstants } from '@enrich/shared-lib';
import { TasksTable } from '../Dashboard/TasksTable';
import { buildInitialTodosQuery } from '../Dashboard/useTodosInfinite';

export const TasksDashboard = () => {
    const { todos = [], todosPagination, error } = useLoaderData();
    const revalidator = useRevalidator();

    return (
        <Main>
            <Page
                kind="full"
                pad={{ top: '30px', bottom: '60px', horizontal: 'small' }}>
                {error && (
                    <PageContent>
                        <Box
                            pad="medium"
                            margin="small"
                            round="small"
                            border={{ color: 'enrich-red', size: '3px' }}>
                            <Text alignSelf="center">Error: {error}</Text>
                        </Box>
                    </PageContent>
                )}

                <PageContent>
                    <Heading level="3">Tasks</Heading>
                    <TasksTable
                        todos={todos}
                        pagination={todosPagination}
                        revalidator={revalidator}
                        showAssignmentFilter
                        showContractClientFilter
                    />
                </PageContent>
            </Page>
        </Main>
    );
};

export async function loader() {
    if (!hasToken()) {
        return redirect('/login');
    }

    const userId = localStorage.getItem(AppConstants.cacheKeys.userId);

    try {
        const todosQuery = buildInitialTodosQuery(userId);
        const todosResponse = await API.get(`/api/to-dos?${todosQuery}`);
        return {
            todos: todosResponse?.data.data,
            todosPagination: todosResponse?.data.meta?.pagination,
        };
    } catch (error) {
        console.log(error);
        return {
            error: error.message,
        };
    }
}
